module.exports = __webpack_public_path__ + "img/Feature.6ef80975.jpg";